import React from 'react';
import ValidatorSummary, { IValidatorDecisionConfig } from 'components/ValidatorSummary';
import { AsyncTaskStatus, ItemSourceGuesserItemStatus as ItemStatus } from 'constants/itemSourceGuesserStatus';
import ItemSourceGuesserItemsModel from 'models/ItemSourceGuesserItemsModel';

interface IProps {
  itemsModel: ItemSourceGuesserItemsModel;
  onFilterChange: (filter: { type: 'status' | 'decision'; value: string } | null) => void;
  activeFilter: { type: 'status' | 'decision'; value: string } | null;
  onClearFilter: () => void;
}

const ItemSourceGuesserSummary: React.FC<IProps> = ({ itemsModel, onFilterChange, activeFilter, onClearFilter }) => {
  const decisions: IValidatorDecisionConfig[] = [
    { key: 'keep', label: 'Keep', color: '#66BB6A' },
    { key: 'change', label: 'Change', color: '#42A5F5' },
    { key: 'accept', label: 'Accept', color: '#AB47BC' },
  ];

  const statusConfig = {
    PENDING: ItemStatus.PENDING,
    NEEDS_USER_REVIEW: ItemStatus.NEEDS_USER_REVIEW,
    DONE: ItemStatus.DONE,
  };

  const asyncTaskStatusConfig = {
    FAILED: AsyncTaskStatus.FAILED,
    DEAD_LETTER: AsyncTaskStatus.DEAD_LETTER,
  };

  // Adapter for filter change to match original signature
  const handleFilterChange = (type: string, value: string) => {
    onFilterChange({ type: type as 'status' | 'decision', value });
  };

  // Don't render anything if there are no items
  if (!itemsModel.gridData || itemsModel.gridData.length === 0) {
    return null;
  }

  return (
    <ValidatorSummary
      items={(itemsModel.gridData as any[]) || []}
      decisions={decisions}
      statusConfig={statusConfig}
      asyncTaskStatus={asyncTaskStatusConfig}
      onFilterChange={handleFilterChange}
      activeFilter={activeFilter}
      onClearFilter={onClearFilter}
      customFeatures={{ noDecision: true }}
      colors={{
        processing: '#9C27B0',
        review: '#FFA726',
        error: '#E53935',
      }}
    />
  );
};

export default ItemSourceGuesserSummary;